import * as Yup from "yup";

export const createRuleValidationSchema = Yup.object({
  ruleName: Yup.string().required("Rule name is required"),
  isActive: Yup.string().required("Status is required"),
  geographyParam: Yup.string().required("Geography Parameter is required"),
  // country: Yup.array().when("geographyParam", {
  //   is: "Country",
  //   then: (schema) =>
  //     schema.min(1, "At least one country must be selected").required("Country is required"),
  //   otherwise: (schema) => schema.notRequired(),
  // }),
  // state: Yup.array().when("geographyParam", {
  //   is: "State",
  //   then: (schema) =>
  //     schema.min(1, "At least one state must be selected").required("State is required"),
  //   otherwise: (schema) => schema.notRequired(),
  // }),
  // city: Yup.array().when("geographyParam", {
  //   is: "City",
  //   then: (schema) =>
  //     schema.min(1, "At least one city must be selected").required("City is required"),
  //   otherwise: (schema) => schema.notRequired(),
  // }),
  // zip: Yup.array().when("geographyParam", {
  //   is: "ZipCode",
  //   then: (schema) =>
  //     schema.min(1, "At least one ZIP must be entered").required("ZIP is required"),
  //   otherwise: (schema) => schema.notRequired(),
  // }),
  // conditionType: Yup.string().required("Condition Type is required"),
  // productType: Yup.string(),
});
